import axios from 'axios';
import Mapper from '../utils/Mapper';
import AccountTypeActions from '../actions/AccountTypeActions.js';
import {MappingConfigurations} from '../constants/AccountTypeConstants.js';
import {APIUrl, ProductIds} from '../constants/ApplicationConstants.js';
import {getError as Error, ThrowIfStatusNotOk} from './ApiHelper.js';

module.exports = {
    getAccountType: function(productId) {
        if (productId === ProductIds.SUPER || productId === ProductIds.PENSION) {
            return;
        }
        const url = APIUrl.BASE_PRODUCTS_URL + productId + APIUrl.ACCOUNT_TYPE_LIST;

        axios.get(url)
            .then(ThrowIfStatusNotOk)
            .then((response) => {
                const data = Mapper.arrayOfObjectMapper(response.data, MappingConfigurations.AccountTypes);
                AccountTypeActions.loadAccountTypeList(data);
            })
            .catch((error) => {
                throw Error('Account Type List', error);
            });
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./apis/AccountTypeAPI.js